import { useEffect } from "react";

const ViewportScaler: React.FC = () => {
  useEffect(() => {
    const updateViewport = () => {
      let viewport = document.querySelector(
        "meta[name=viewport]"
      ) as HTMLMetaElement;

      if (!viewport) {
        viewport = document.createElement("meta") as HTMLMetaElement;
        viewport.name = "viewport";
        document.head.appendChild(viewport);
      }

      // console.log("window innerWidth", window.innerWidth);
      const scale = window.innerWidth <= 1300 ? "0.8" : "1.0";
      viewport.setAttribute(
        "content",
        `width=device-width, initial-scale=${scale}`
      );
    };

    updateViewport(); // Initial run

    window.addEventListener("resize", updateViewport);

    return () => {
      window.removeEventListener("resize", updateViewport);
    };
  }, []);

  return null; // It's a utility component, nothing to render
};

export default ViewportScaler;
